import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['container']
  connect () {

  }

  toggle (e) {
    let options = e.currentTarget.dataset.options.split(',')
    let answer = options.find(option => option === e.currentTarget.value);
    console.log(options)
    console.log(answer)
    if (answer !== undefined) {
      this.show()
    } else {
      this.hide()
    }
  }

  show () {
    for (let container of this.containerTargets) {
      container.classList.remove('hidden')
    }
  }

  hide () {
    for (let container of this.containerTargets) {
      container.classList.add('hidden')
    }
  }
}
